<template>
  <el-row :gutter="20" class="d-flex flex-wrap">
    <el-col :md="6" class="d-flex mb-2">
      <add-new-card
        :min-height="$breakpoint.mdAndUp ? '460px' : '164px'"
        :disabled="disabled"
        :title="title"
        @click="onClick"
      />
    </el-col>
    <el-col
      v-if="$breakpoint.mdAndUp"
      :md="6"
      class="d-flex mb-2"
    >
      <ib-grid-view-placeholder-card class="w-100" :disabled="disabled" />
    </el-col>
    <el-col
      v-if="$breakpoint.mdAndUp"
      :md="6"
      class="d-flex mb-2"
    >
      <ib-grid-view-placeholder-card class="w-100" :disabled="disabled" variant="yellow" />
    </el-col>
  </el-row>
</template>

<script>
import AddNewCard from '@/components/_v2/AddNewCard.vue'

export default {
  name: 'IbGridViewPlaceholder',

  components: { AddNewCard },

  props: {
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClick () {
      if (this.disabled) return
      this.$emit('click')
    }
  }
}
</script>
